<template>
  <footer class="the-footer">
    <BaseImage
      v-if="footerImage"
      :id="footerImage"
      class="the-footer__background"
    />
    <div class="the-footer__inner">
      <LogoStraight class="the-footer__logo" />
      <ul class="footer-menu__list">
        <li
          v-for="({ text, to }) in links"
          :key="text"
          class="footer-menu__list-item"
        >
          <router-link
            :to="to"
            class="footer-menu__link"
            v-text="text"
          />
        </li>
      </ul>
      <ul class="footer-social__list">
        <li class="footer-social__list-item">
          <a
            class="footer-social__link"
            href="https://www.facebook.com/UNLTDtennis18/">
            <span class="access-hidden">Facebook</span>
            <FacebookIcon class="footer-social__icon"/>
          </a>
        </li>
        <li class="footer-social__list-item">
          <a
            class="footer-social__link"
            href="https://www.instagram.com/unltdtennis/">
            <span class="access-hidden">Instagram</span>
            <InstagramIcon class="footer-social__icon"/>
          </a>
        </li>
      </ul>
      <div class="the-footer__court-wrapper">
        <CourtHalf
          expand
          class="court the-footer__court"
          side="bottom"
        />
      </div>
      <span class="the-footer__copyright">Copyright UNLTD 2018</span>
    </div>
  </footer>
</template>
<script>
  import Menu from '@/api/menus';
  import Option from '@/api/options';
  import { cleanMenuItem } from '@/util/cleaners';

  import TextDelta from '@/components/TextDelta';
  import CourtHalf from '@/components/CourtHalf';
  import YoutubeIcon from '@/components/YoutubeIcon';
  import LogoStraight from '@/components/LogoStraight';
  import FacebookIcon from '@/components/FacebookIcon';
  import InstagramIcon from '@/components/InstagramIcon';

  export default {
    components: {
      TextDelta,
      LogoStraight,
      FacebookIcon,
      InstagramIcon,
      YoutubeIcon,
      CourtHalf,
    },
    data() {
      return {
        links: undefined,
        footerImage: undefined,
      };
    },
    created() {
      this.fetchLinks();
      this.fetchFooterImage();
    },
    methods: {
      async fetchLinks() {
        this.links = (await Menu.find('footer')).map(cleanMenuItem);
      },
      async fetchFooterImage() {
        this.footerImage = (await Option.find('theme-settings')).acf.footer_image;
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .the-footer {
    position: relative;
    z-index: 2;
    padding-top: spacing(base-epsilon);
    padding-bottom: spacing(base-delta);
    background-color: color(slate);

    @include breakpoint(tablet) {
        padding-top: spacing(base-eta);
    }
  }

  .the-footer__inner {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .the-footer__background {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .access-hidden {
    @include access-hidden;
  }

  .footer-menu__link {
    font-family: font-family(san-serif);
    font-weight: font-weight(bold);
    text-transform: uppercase;
    color: color(bronze);
    transition-property: color;
    transition-timing-function: timing-function(accelerate);
    transition-duration: duration(fast);

    &:hover,
    &:focus {
      color: color(red);
      transition-timing-function: timing-function(decelerate);
    }
  }

  .footer-social__link {
    display: inline-block;
    width: 25px;

    &:hover,
    &:focus {
      .footer-social__icon {
        fill: color(red);
        transition-timing-function: timing-function(decelerate);
      }
    }
  }

  .footer-social__icon {
    fill: color(bronze);
    transition-property: fill;
    transition-timing-function: timing-function(accelerate);
    transition-duration: duration(fast);
  }

  .footer-menu__list {
    margin-top: spacing(base-epsilon);
    margin-bottom: spacing(base-epsilon);
  }

  .footer-social__list-item {
    display: inline-block;
  }

  .footer-menu__list-item {
    display: block;
    text-align: center;

    @include breakpoint(phablet) {
      display: inline-block;
      text-align: left;
    }
  }

  .footer-menu__list-item {
    margin-top: spacing(base-epsilon);

    &:first-child {
      margin: 0;
    }

    @include breakpoint(phablet) {
      margin-left: spacing(base-epsilon);
    }
  }

  .footer-social__list-item {
    margin-right: spacing(base-delta);

    &:last-child {
      margin-right: 0;
    }
  }

  .the-footer__logo {
    height: 35px;
    fill: color(bronze);
  }

  .the-footer__court-wrapper {
    margin-top: spacing(base-epsilon);

    @include breakpoint(tablet) {
        margin-top: spacing(base-eta);
    }
  }

  .the-footer__court {
    color: color(red);
  }

  .the-footer__court-wrapper {
    @include column;

    width: 100%;
    max-width: $max-width;
  }

  .the-footer__copyright {
    display: block;
    margin-top: spacing(base-delta);
    color: color(grey);
    font-family: font-family(sans-serif);
    font-size: 1.3rem;
    font-weight: font-weight(bold);
    text-transform: uppercase;
  }
</style>
